import { api } from '@/shared/lib/axios.ts';
import type {
  PublicStatusResponse,
  PublicUptimeResponse,
  PublicIncidentsResponse,
  PublicMaintenancesResponse,
  PublicProbesResponse,
} from '@/pages/public/types.ts';

export async function fetchAdminTenantStatus(tenantId: string) {
  const { data } = await api.get<PublicStatusResponse>(`/admin/tenants/${tenantId}/status`);
  return data;
}

export async function fetchAdminTenantUptime(
  tenantId: string,
  raw = false,
  excludeMaintenance = false,
) {
  // raw = visão "real" (barras por amostra bruta, sem anti-flap); excludeMaintenance = descontar
  // manutenções do cálculo real. Só a página interna usa.
  const params: Record<string, boolean> = {};
  if (raw) params.raw = true;
  if (excludeMaintenance) params.excludeMaintenance = true;
  const { data } = await api.get<PublicUptimeResponse>(`/admin/tenants/${tenantId}/uptime`, {
    params: Object.keys(params).length ? params : undefined,
  });
  return data;
}

export async function fetchAdminTenantIncidents(tenantId: string) {
  const { data } = await api.get<PublicIncidentsResponse>(`/admin/tenants/${tenantId}/incidents`);
  return data;
}

export async function fetchAdminTenantMaintenances(tenantId: string) {
  const { data } = await api.get<PublicMaintenancesResponse>(`/admin/tenants/${tenantId}/maintenances`);
  return data;
}

export async function fetchAdminTenantProbes(tenantId: string, from: string, to: string) {
  const { data } = await api.get<PublicProbesResponse>(`/admin/tenants/${tenantId}/probes`, {
    params: { from, to },
  });
  return data;
}
